(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/play/leia/game-launcher.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/play/leia/game-launcher.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  checkLoggedIn
} = svs.eInstant.util;
const {
  Payfooter
} = svs.tur.ReactPayfooter;
const {
  GameLauncherLeia,
  GameWrapper,
  TopBar,
  Receipt,
  LoaderTicket
} = svs.ticketgames.ticketUtility.components;
const {
  resizeFromFullscreen,
  resizeFromTicketInfo,
  defaultEventsLeiaFactory,
  showDialog,
  tracking
} = svs.ticketgames.ticketUtility.utils;
const {
  gameEngineCode
} = svs.ticketgames.ticketUtility.utils.constants.leia;
const {
  useEffect,
  useContext,
  useState,
  useCallback
} = React;
const onClose = () => {
  window.location.href = svs.core.data.baseUrl;
};
setGlobal('svs.eInstant.play.leia.onPlay', ticketInfo => {
  const isWillNavigate = checkLoggedIn(false, svs.core.data.baseUrl + ticketInfo.playUrl);
  if (isWillNavigate) {
    if (ticketInfo.open) {
      window.location.href = svs.core.data.baseUrl + ticketInfo.playUrl;
    } else {
      window.location.href = svs.core.data.baseUrl;
    }
  }
});
const GameLauncher = () => {
  var _wager$properties;
  const [fullScreenMargin, setFullScreenMargin] = useState(false);
  const [wrapperSize, setWrapperSize] = useState({});
  const {
    wager,
    isDemo,
    ticketInfo
  } = useContext(svs.eInstant.play.PlayContext);
  const {
    useCustomEvents
  } = svs.eInstant.play.leia;
  const {
    hideFooter,
    showFooter
  } = svs.eInstant.play.utils;
  const {
    handleGameLoaded,
    handleOngoingGame,
    handleHasClaimed,
    handleSoundStatus,
    isLoading,
    soundStatus,
    shouldShowPlayAgain,
    handleHasBet
  } = useCustomEvents({
    ticketInfo,
    wager,
    isDemo,
    onClose,
    onPlay: svs.eInstant.play.leia.onPlay
  });
  const wagerId = wager === null || wager === void 0 || (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalWagerId;
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  const shouldShowReceipt = !isLoading && (wager === null || wager === void 0 ? void 0 : wager.completed);
  const gameAvailable = Boolean(wager) || ticketInfo.open;
  const betId = ticketInfo.gameEngineCode === gameEngineCode.VEIKKAUS ? wagerId === null || wagerId === void 0 ? void 0 : wagerId.replace('/LEA', '') : parseInt(wagerId, 10);
  useEffect(() => {
    const defaultEventsLeia = defaultEventsLeiaFactory({
      ticketInfo,
      isDemo,
      isEInstant: true,
      isReplay: wager === null || wager === void 0 ? void 0 : wager.completed,
      onClose: () => {}
    });
    const customEvents = [{
      eventName: 'GAME_LOADING',
      handler: handleGameLoaded
    }, {
      eventName: 'TAG',
      handler: handleOngoingGame
    }, {
      eventName: 'SOUND_STATUS',
      handler: handleSoundStatus
    }, {
      eventName: 'HAS_CLAIMED',
      handler: handleHasClaimed
    }, {
      eventName: 'HAS_BET',
      handler: handleHasBet
    }];

    [...defaultEventsLeia, ...customEvents].forEach(evt => addEventListener(evt.eventName, evt.handler));
    if (!gameAvailable) {
      svs.ticketgames.ticketUtility.utils.showGameClosedDialog({
        isDemo,
        onClose,
        gameCode: ticketInfo.type || ticketInfo.name
      });
    }
    hideFooter();
    return () => {
      [...defaultEventsLeia, ...customEvents].forEach(evt => removeEventListener(evt.eventName, evt.handler));
      showFooter();
    };
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  return gameAvailable ? React.createElement("div", {
    className: isFullScreenGame ? '' : "padding-top-2".concat(!wager ? ' padding-bottom-2' : '')
  }, React.createElement(GameWrapper, {
    context: {
      isDemo,
      ticketInfo,
      wager,
      betId,
      isEInstant: true
    },
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      showDialog({
        type: 'close',
        isDemo,
        onClose
      });
    },
    onSoundClick: () => {
      svs.ticketgames.falconBridge.falcon.instance.notifierProxy.notifySoundStatus(!soundStatus);
    },
    trackingLabel: tracking.createTopBarTrackingLabel({
      isDemo,
      location: wager ? 'mina-spel' : 'spela',
      gameCode: ticketInfo.type
    })
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    onResize: onResize
  }, isLoading && React.createElement(LoaderTicket, null))), shouldShowReceipt && React.createElement(Receipt, {
    fetchedGame: wager,
    style: {
      opacity: 0
    },
    ticketInfo: ticketInfo
  }), shouldShowPlayAgain && React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Spela igen',
      onClick: () => svs.eInstant.play.leia.onPlay(ticketInfo)
    }],
    isFixed: true
  })) : React.createElement("div", null);
};
setGlobal('svs.eInstant.play.leia.GameLauncher', GameLauncher);

 })(window);